import React from 'react'

const SuccessIcon = () => {
    return (
        <svg
            //  width="24" height="24" 
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_488_391)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM10.8 18C10.8 17.3373 11.3373 16.8 12 16.8C12.6627 16.8 13.2 17.3373 13.2 18C13.2 18.6627 12.6627 19.2 12 19.2C11.3373 19.2 10.8 18.6627 10.8 18ZM11.1 14.4C11.1 14.8971 11.5029 15.3 12 15.3C12.4971 15.3 12.9 14.8971 12.9 14.4L12.9 6C12.9 5.50294 12.4971 5.1 12 5.1C11.5029 5.1 11.1 5.50294 11.1 6L11.1 14.4Z" fill="#039855" />
            </g>
            <defs>
                <clipPath id="clip0_488_391">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}

export default SuccessIcon